import axios from '../api/index.js';

//获取课程树
export let getCourseTreeList = (params) => {
    return axios.get(`/client/course/tree/list/${params}`);
};

//获取课程树(子集)
export let getCourseTreeChildList = (params) => {
    return axios.get(`/client/course/tree/list/children/${params}`);
};

//获取课程树(父级包括本身)
export let getCourseTreeParentList = (params) => {
    return axios.get(`/client/course/tree/list/parent/${params}`);
};

//查询课程树详情
export let getCourseTreeDetail = (params) => {
    return axios.get(`/client/course/tree/${params}`);
};

//获取课程列表
export let getCourseList = (params) => {
    return axios.post(`/client/course/list`, params);
};

//查询课程详情
export let getCourseDetail = (params) => {
    return axios.get(`/client/course/${params}`);
};

//获取课程树
export let getCourseChapterTreeList = (params) => {
    return axios.get(`/client/course/chapter/tree/list/${params}/0`);
};

//获取章节资源
export let getCourseChapterSourceList = (params) => {
    return axios.post(`/client/course/chapter/source/list/${params}`);
};

//查询章节资源详情
export let getCourseChapterSourceDetail = (params) => {
    return axios.get(`/client/course/chapter/source/${params}`);
};

//获取视频播放权限
export let getCourseVideoPlayauth = (params) => {
    return axios.get(`/client/common/video/query/playauth?key=${params}`);
};

//新增用户播放进度
export let postCourseVideoPlaySchedule = (params) => {
    return axios.post(`/client/user-course/source/schedule`, params);
};

//用户播放完成
export let postCourseVideoPlayScheduleOver = (params) => {
    return axios.post(`/client/user-course/sourceOver/schedule`, params);
};

//获取用户播放进度
export let getCourseVideoPlaySchedule = (params) => {
    return axios.get(`/client/user-course/source/${params}`);
};

//获取用户某课程
export let getUserCourse = (params) => {
    return axios.get(`/client/user-course/${params}`);
};

//获取用户某课程是否有权限
export let getUserCourseAuth = (params) => {
    return axios.get(`/client/user-course/auth/${params}`);
};

//用户播放进度及学习记录
export let postCourseSourceSchedule = (params) => {
    return axios.post(`/client/user-course/source/schedule`, params);
};

//获取用户课程
export let getUserCourseList = (params) => {
    return axios.post(`/client/user-course/list`, params);
};

//获取课程免责
export let getCourseStatement = () => {
    return axios.get(`/client/course/statement`);
};

//根据课程编号授权课程
export let getAuthUserCourseByCourseId = (params) => {
    return axios.get(`/client/user-course/authUserCourseByCourseId/${params}`);
};

//获取舞美个人课程
export let getUserCourseWM = (params) => {
    return axios.get(`/client/user-course/${params}`);
};




// WEBPACK FOOTER //
// ./src/api/edu.js